import React from "react";

import { CardBody, Container, Modal, Popover } from "reactstrap";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { MobileDateRangePickerWrapper } from "@components/Common/MobileDateRangePickerWrapper";
import DateRangePickerWrapper from "@components/Common/DateRangePickerWrapper";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import HeaderComponent from "@components/VerticalLayout/HeaderComponent";
import { StyledPopoverBody } from "@pages/connecs/StyledPopoverBody";
import BreadcrumbOptions from "@pages/Reporting/BreadcrumbOptions";
import { getAdvancedPeriodStringParam } from "@helpers/general";
import PageTitle from "@components/Common/PageTitle";

import NoDataOverlay from "@pages/connecs/NoDataOverlay";
import { CustomFooter } from "@pages/connecs/CustomFooter";
import { Box } from "@mui/material";
import { TransactionsReportingModal } from "./TransactionsReportingModal";

function SoftaveraTransactionsEcomOverview() {
    const { t } = useTranslation();

    const { periodSlice, advancedDate } = useSelector((state: any) => state);
    const [isTransactionsModalOpened, setIsTransactionsModalOpened] =
        React.useState<boolean>(false);
    const [rowData] = React.useState<string>("");
    const [, setTransactionData] = React.useState<any>();
    const pageSize = isMobile ? 5 : 10;

    const uuidEntity = localStorage.getItem("Uid_Entitie_User");

    const [currentPage, setCurrentPage] = React.useState(0);
    const [rows, setRows] = React.useState([]);
    const totalPages = Math.ceil(rows.length / pageSize);
    const [isPopoverOpened, setIsPopoverOpened] = React.useState(false);
    const [isModalOpened, setIsModalOpened] = React.useState<boolean>(false);

    const handlePageChange = (newPage: number) => {
        if (newPage >= 0 && newPage < totalPages) {
            setCurrentPage(newPage);
        }
    };

    const toggleOpenedPopover = React.useCallback(() => {
        setIsPopoverOpened((prevState) => !prevState);
    }, []);

    const toggleOpeningModal = React.useCallback(() => {
        setIsModalOpened((prevState) => !prevState);
    }, []);

    const handleToggleOpeningModal = React.useCallback(() => {
        toggleOpeningModal();
    }, [toggleOpeningModal]);

    const handleToggleOpenedPopover = React.useCallback(() => {
        toggleOpenedPopover();
    }, [toggleOpenedPopover]);

    const columns: GridColDef[] = [
        {
            field: "date",
            headerName: "Date",

            width: 230,
            editable: false,
        },
        {
            field: "totalCmd",
            headerName: "Total des Transactions",

            width: 230,
            editable: false,
        },
        {
            field: "totalFrais",
            headerName: "Total des frais",

            width: 220,
            editable: false,
        },
        {
            field: "totalFraisFranchise",
            headerName: "Frais Franchise",

            width: 220,
            editable: false,
        },
        {
            field: "totalFraisSoftavera",
            headerName: "Frais Softavera",

            width: 220,
            editable: false,
        },
        {
            field: "totalRenverser",
            headerName: "Total à verser",

            width: 250,
            editable: false,
        },
        {
            field: "versementDate",
            headerName: "Date de Versement",

            width: 250,
            editable: false,
        },
    ];

    async function getTransactionsReporting() {
        const filterPeriod = getAdvancedPeriodStringParam(
            periodSlice,
            advancedDate
        );
        const encodedFilterPeriod = encodeURIComponent(filterPeriod);
        const response = await fetch(
            `${process.env.REACT_APP_ADMIN_ACCESS}/getTransactionsReporting?inputDate=${encodedFilterPeriod}&uuidEntity=${uuidEntity}&merchentAccount=${process.env.REACT_APP_MERCHENT_ECOM}`
        );
        if (!response.ok) {
            throw new Error(`Error fetching data: ${response.status}`);
        }
        const data = await response.json();
        setTransactionData(data);
        return data.map((item: any, index: number) => {
            return {
                id: index,
                date: item.date,
                totalCmd: ` ${item.totalCmd} ${item.currency}`,
                totalFrais: `${item.totalFrais} ${item.currency}`,
                totalRenverser: `${item.totalRenverser} ${item.currency}`,
                dateRenversement: "",
                totalFraisFranchise: item.totalFraisFranchise,
                totalFraisSoftavera: item.totalFraisSoftavera,
                versementDate: item.versementDate,
            };
        });
    }

    React.useEffect(() => {
        const loadRows = async () => {
            const fetchedRows: any = await getTransactionsReporting();
            setRows(fetchedRows);
        };

        loadRows();
        // eslint-disable-next-line
    }, [uuidEntity, periodSlice, advancedDate]);

    return (
        <React.Fragment>
            <div>
                <PageTitle title="Reporting SoftaveraPay" />
                <div className="">
                    <BreadcrumbOptions
                        currentLink={[
                            {
                                item: t("SOFTAVERAPAY"),
                                link: `${process.env.REACT_APP_PORTAIL_API}`,
                            },
                            {
                                item: t(`${"Reporting"}`),
                                link: `${"Reporting"}`,
                            },
                            // {
                            //     item: t(`${"Reporting journalier Ecommerce"}`),
                            //     link: `${"Reporting journalier Ecommerce"}`,
                            // },
                        ]}
                    />
                    <Container fluid>
                        <HeaderComponent
                            title={t(`The daily report shows the total transactions per day, the total fees, as well as the total after fee deductions.`)}
                        />
                        <CardBody
                            style={{
                                padding: "1px",
                                backgroundColor: "white",
                                marginTop: "10px",
                            }}
                        >
                            <div>
                                <div className="transaction-overview">
                                    {/* <h2>Reporting journalier Ecommerce overview</h2> */}
                                    <div className="filter-buttons">
                                        <button
                                            id="date-range-picker-popover"
                                            type="button"
                                            className="filter-button active"
                                            onClick={handleToggleOpenedPopover}
                                        >
                                            {t(`${periodSlice.date}`)}
                                        </button>
                                        {isPopoverOpened &&
                                            (isMobile === false ? (
                                                <Popover
                                                    placement="top"
                                                    isOpen={isPopoverOpened}
                                                    target="date-range-picker-popover"
                                                    toggle={toggleOpenedPopover}
                                                    trigger="legacy"
                                                >
                                                    <StyledPopoverBody>
                                                        <DateRangePickerWrapper
                                                            toggleOpenedPopover={
                                                                toggleOpenedPopover
                                                            }
                                                            isAdvancedReporting
                                                        />
                                                    </StyledPopoverBody>
                                                </Popover>
                                            ) : (
                                                <Modal
                                                    isOpen={isModalOpened}
                                                    toggle={
                                                        handleToggleOpeningModal
                                                    }
                                                    className="defined-range-modal__clz"
                                                    centered
                                                    fade={false}
                                                >
                                                    <MobileDateRangePickerWrapper
                                                        toggleOpeningModal={
                                                            handleToggleOpeningModal
                                                        }
                                                    />
                                                </Modal>
                                            ))}

                                        <button
                                            className="filter-button d-none"
                                            type="button"
                                        >
                                            Libellé
                                        </button>
                                    </div>
                                </div>
                                <Box sx={{ height: 500, width: "100%" }}>
                                    <DataGrid
                                        rows={rows.slice(
                                            currentPage * pageSize,
                                            (currentPage + 1) * pageSize
                                        )}
                                        columns={columns.map((column) => ({
                                            ...column,
                                        }))}
                                        pageSize={pageSize}
                                        disableSelectionOnClick
                                        components={{
                                            NoRowsOverlay: NoDataOverlay,
                                            Footer: CustomFooter,
                                        }}
                                        componentsProps={{
                                            footer: {
                                                currentPage,
                                                onPageChange: handlePageChange,
                                                totalPages,
                                            },
                                        }}
                                    />
                                </Box>
                            </div>
                        </CardBody>
                    </Container>
                </div>
            </div>
            <TransactionsReportingModal
                isModalOpened={isTransactionsModalOpened}
                setIsModalOpened={setIsTransactionsModalOpened}
                data={rowData}
            />
        </React.Fragment>
    );
}

export default SoftaveraTransactionsEcomOverview;
